import module from 'fanconsultores/module.js'
import template from './template.html'
import './style.scss'

class AppNotsupportedComponent {
}

module.component('appNotsupported', {
  controller: AppNotsupportedComponent,
  template,
})



// WEBPACK FOOTER //
// ./src/fanconsultores/components/app/notsupported/component.js